import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'smartflip-home-list-subscription-banner',
  imports: [CommonModule, IonicModule],
  templateUrl: './home-list-subscription-banner.component.html',
  styleUrl: './home-list-subscription-banner.component.scss',
})
export class HomeListSubscriptionBannerComponent implements OnInit {
  @Input() isPremiumUser: boolean = false;

  public hideBanner: boolean = true;

  public closeBannerMessage() {
    this.hideBanner = true;
  }

  ngOnInit(): void {
    this.hideBanner = this.isPremiumUser;
  }
}
